import React, { Component } from 'react'
import config from '../../config.json'
import SiteLogo from '../../General/SiteLogo'
import FilterResultsViewButtons from '../FilterResultsViewButtons'
import { SiteSlidebarLeft } from '../../General/SiteSlidebars'
import hasSlidebarLeft from '../../hoc/hasSlidebarLeft'
import SecondaryFilter from './SecondaryFilter'
import ActiveFilters from './ActiveFilters'
import PrimaryFilter from './PrimaryFilter'
import getFilterStrings from '../../functions/getFilterStrings.jsx'
import Translation from '../../General/Translation'
import SearchFilter from './SearchFilter.jsx'
import MovieSearchFormContainer from '../../MovieSearchForm/MovieSearchFormContainer.jsx'

const breakpoints = config.breakpoints

class OverviewFilter extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { allItems, dayFilters, searchFilter, filters, activeFilters, activeView, cinemaFrontPkType, dayFilterDisplay, openDayFilter, theme, toggleDayFilter, informationStyling, siteHeaderData, movies, queryStringValues, onChangeOverviewView, filterDisplay, toggleFilter, openFilter, translation, hasShowtimesFeature, hasGridTrailerFeature } = this.props
        const { displaySidebarLeft, isMobile, onSidebarLeftToggle } = this.props
        const filterStrings = getFilterStrings(queryStringValues)
        const activeFiltersWithoutTime = _.omit(activeFilters, 'time')
        const mainClass = displaySidebarLeft ? ' filters-open' : ' filters-close'
        const hasDesktopExtendedSearch = (!isMobile && filterDisplay === 'display') || (!isMobile && filterDisplay === 'foldable' && openFilter)

        return (
            <div className={"overview-filter overview-filter-desktop" + mainClass + ' ' + informationStyling}>
                <div className="grid-site-wrapper">
                    <div>
                        <div className="overview-filter-header">
                            <FilterResultsViewButtons 
                                changeView={onChangeOverviewView}
                                hasShowtimesFeature={hasShowtimesFeature}
                                hasGridTrailerFeature={hasGridTrailerFeature}
                                activeView={activeView}
                            />

                            <PrimaryFilter 
                                allItems={allItems}
                                movies={movies}
                                theme={theme}
                                isMobile={isMobile}
                                dayFilters={dayFilters}
                                filterStrings={filterStrings}
                                toggleFilter={toggleFilter}
                                toggleDayFilter={toggleDayFilter}
                                openDayFilter={openDayFilter}
                                onSidebarLeftToggle={onSidebarLeftToggle}
                                queryStringValues={queryStringValues}
                                filterDisplay={filterDisplay}
                                dayFilterDisplay={dayFilterDisplay}
                                translation={translation}
                            />

                            {isMobile && filterDisplay !== 'hidden' ? ( <ActiveFilters
                                filterStrings={filterStrings}
                                filters={filters}
                                allItems={allItems}
                                activeFiltersWithoutTime={activeFiltersWithoutTime}
                                translation={translation}
                            />) : (
                                ''
                            )}
                        </div>
                    </div>

                    {hasDesktopExtendedSearch && <div className="overview-filter-list">
                        <SearchFilter
                            queryStringValues={queryStringValues}
                            searchFilter={searchFilter}
                            filterStrings={filterStrings}
                            allItems={allItems}
                            translation={translation}
                        />
                        <SecondaryFilter
                            filters={filters}
                            movies={movies}
                            filterStrings={filterStrings}
                            allItems={allItems}
                            queryStringValues={queryStringValues}
                            cinemaFrontPkType={cinemaFrontPkType}
                            translation={translation}
                        /> 
                    </div>}

                    {displaySidebarLeft && <SiteSlidebarLeft informationStyling={informationStyling}>
                        <div 
                            className="site-slidebar-overlay accent-color-background-half-transparent" 
                            onClick={onSidebarLeftToggle}
                        />

                        <div className="site-slidebar-content accent-color-background-half-transparent">
                            <div className="item-header logo-wrapper">
                                <SiteLogo 
                                    siteHeaderData={siteHeaderData}
                                />
                            </div>

                            <div className="overview-filter overview-filter-mobile">


                                <MovieSearchFormContainer
                                    textClass='text-light'
                                    translation={translation}
                                />

                                <ActiveFilters
                                    filters={filters}
                                    filterStrings={filterStrings}
                                    allItems={allItems}
                                    activeFiltersWithoutTime={activeFiltersWithoutTime}
                                    translation={translation}
                                />
                 
                                <div className="close-filter-list cursor-pointer" onClick={() => onSidebarLeftToggle()}>
                                    <div className="title-large button">{0 === Object.keys(activeFiltersWithoutTime).length ? <Translation id="back" trans={translation}>Zurück</Translation> : <Translation id="applyFilters" trans={translation}>Filter anwenden</Translation>}</div>
                                </div>
                        
                                <div className="overview-filter-list">
                                    <SecondaryFilter 
                                        filters={filters}
                                        movies={movies}
                                        filterStrings={filterStrings}
                                        allItems={allItems}
                                        queryStringValues={queryStringValues}
                                        cinemaFrontPkType={cinemaFrontPkType}
                                        translation={translation}
                                    />
                                </div>
                            </div>
                        </div>
                    </SiteSlidebarLeft>}
                </div>
            </div>
        )
    }

}

export default hasSlidebarLeft({breakpoint: breakpoints.slidebarLeft})(OverviewFilter)